export const modalCss = {
  zIndex: 99,
};

export const footerCss = {
  minHeight: "unset",
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
};
